import { jsString } from '.';
export const emitToken = (value, parseNode) => {
    return {
        kind: 'token',
        parseNode,
        value
    };
};
export const emitTree = (nodes, parseNode) => {
    return {
        kind: 'node',
        nodes: nodes.filter(n => n).map(n => n),
        parseNode
    };
};
export const emitAppendStr = (node, str) => {
    if (node.kind === 'node') {
        node.nodes.push(emitToken(str));
    }
    else {
        node.value += str;
    }
    return node;
};
export const jsVariable = (name, emit, pub = false) => {
    const pubStr = pub ? 'export ' : '';
    if (emit) {
        return emitTree([emitToken(`${pubStr}let ${name} = `), emit, emitToken(';')]);
    }
    else {
        return emitToken(`${pubStr}let ${name};`);
    }
};
export const jsError = (message) => {
    const msg = `codegen error: ${message ?? ''}`;
    return emitToken(`(() => { throw Error(${jsString(msg)}); })()`);
};
export const emitIntersperse = (lines, separator, parseNode) => {
    return emitTree(lines
        .filter(l => !!l)
        .map(l => l)
        .filter(l => l.kind === 'node' || l.value.length > 0)
        .map((l, i, ls) => {
        if (i !== ls.length - 1) {
            return emitAppendStr(l, separator);
        }
        return l;
    }), parseNode);
};
//# sourceMappingURL=node.js.map